module.exports = __webpack_public_path__ + "static/img/5.8326a49f.png";